import styled from 'styled-components';

import { TableTitle } from 'components/TableTitle';

const Container = styled.div`
  padding: 1rem 6rem;
`;

const Title = styled(TableTitle)`
  margin-bottom: 4rem;

  &:not(:first-of-type) {
    margin-top: 4rem;
  }
`;

export { Container, Title };
